import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=2d918aee&"
import script from "./EventPage.vue?vue&type=script&lang=js&"
export * from "./EventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports